import geoutils from './helper/geo'
import { ShapeMaker, TransformContext } from './types'

export type MultiPolygonOptions = {
  coords: number[][][]
  /* @deprecated use stroke instead */
  color?: string
  stroke?: string
  fill?: string
  width?: number
  simplify?: boolean
}

export default class MultiPolygonMaker implements ShapeMaker {
  coords: number[][][]
  /* @deprecated use stroke instead */
  color?: string
  stroke?: string
  fill?: string
  width?: number
  simplify?: boolean

  constructor(options: MultiPolygonOptions) {
    this.coords = options.coords
    this.color = options.color
    this.stroke = options.stroke
    this.fill = options.fill
    this.width = Number.isFinite(options.width) ? Number(options.width) : 3
    this.simplify = options.simplify || false
  }

  /**
   * calculate the coordinates of the envelope / bounding box: (min_lon, min_lat, max_lon, max_lat)
   */
  extent() {
    const allPoints = this.coords[0]

    return [
      Math.min(...allPoints.map(c => c[0])),
      Math.min(...allPoints.map(c => c[1])),
      Math.max(...allPoints.map(c => c[0])),
      Math.max(...allPoints.map(c => c[1])),
    ] as [number, number, number, number]
  }

  static toSVG(shape: MultiPolygonMaker, context: TransformContext) {
    const shapeArrays = shape.coords.map(shape =>
      shape.map(coord => [
        context.xToPx(geoutils.lonToX(coord[0], context.zoom)),
        context.yToPx(geoutils.latToY(coord[1], context.zoom)),
      ])
    )

    const pathArrays = []

    for (const points of shapeArrays) {
      const startPoint = points.shift()

      if (!startPoint) continue

      const pathParts = [
        `M ${startPoint[0]} ${startPoint[1]}`,
        ...points.map(p => `L ${p[0]} ${p[1]}`),
        'Z',
      ]

      pathArrays.push(pathParts.join(' '))
    }

    return `<path
    d="${pathArrays.join(' ')}"
    style="fill-rule: inherit;"
    stroke="${shape.stroke ?? shape.color ?? '#000000BB'}"
    fill="${shape.fill ? shape.fill : 'none'}"
    stroke-width="${shape.width}"/>`
  }

  toSVG(context: TransformContext) {
    return MultiPolygonMaker.toSVG(this, context)
  }
}
